import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { deepCopy } from '@delon/util';
import { TemplateService } from '../../services/template.service';
import { _MSGTYPES } from '../../constant/msgType';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-copy',
  template: `
    <nz-form-item>
      <nz-form-label [nzSpan]="3">复用已有模板</nz-form-label>
      <nz-form-control [nzSpan]="10">
        <nz-select style="width: 210px;" nzPlaceHolder="请选择已有模板" (click)="provinceClick()" [(ngModel)]="item.copyValue" [nzShowSearch]="true" (ngModelChange)="provinceChange($event)">
          <nz-option [nzValue]="0" nzLabel="请选择"></nz-option>
          <!-- <nz-option *ngFor="let option of copyList; index as j" [nzValue]="option.htmlId" [nzLabel]="option.name + '【' + _MSGTYPES.getMsgByType(false, option.msgType).name + '】'"> </nz-option> -->
          <nz-option *ngFor="let option of copyList; index as j" [nzValue]="option.htmlId" [nzLabel]="option.name"> </nz-option>
        </nz-select>

        <span class="iconfont icon-wenhao wenhao" nz-popover nzPopoverTrigger="click" [nzPopoverContent]="copyContentTemplate" nzPopoverPlacement="leftTop"></span>
        <ng-template #copyContentTemplate>
          <div>
            1、选取当前业务类型下的模板名称，可快速复用该模板内容，可免除重复填充内容的操作；<br />
            2、若被复用内容过长，根据当前消息类型所限制的字符长度进行对内容的截取；<br />
            3、复用规则：<br />
            短信可复用短信、语音、极光推送；<br />
            微信仅可复用微信；<br />
            语音可复用短信、语音、极光推送；<br />
            邮件可复用短信、语音、邮件、极光推送；<br />
            极光推送可复用短信、语音、极光推送；<br />
            企业微信可复用企业微信；<br />
            5G消息可复用5G消息。<br />
          </div>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  `,
})
export class IccTplCopyComponent implements OnInit {
  /** 消息类型 */
  @Input() type: any;
  /** 辅助的激活下标 */
  @Input() actIndex: any;
  /** 当前模板的索引 */
  @Input() index: number;
  /** 模板更新后的回调 */
  @Output() update = new EventEmitter<any>();
  /** 复用的回调 */
  @Output() copyChange = new EventEmitter<any>();

  /** 复用列表 */
  copyList = [];

  /** 当前消息类型下的模板 */
  item: any;

  /** 辅助 --消息类型 */
  _MSGTYPES = _MSGTYPES;

  constructor(private templateService: TemplateService) {}

  ngOnInit() {
    this.item = this.templateService.getTpl(this.type)[this.index] || [];
    this.copyList = deepCopy(this.templateService.getTemplateByRefMap(this.type, this.item));
    for (let i = 0; i < this.copyList.length; i++) {
      this.copyList[i].name = this.copyList[i].name + '【' + _MSGTYPES.getMsgByType(false, this.copyList[i].msgType).name + '】';
    }
  }

  provinceChange(htmlId: any): void {
    if (htmlId) {
      const result = this.copyList.filter(it => it.htmlId === htmlId)[0];
      this.copyChange.next(result);
    }
  }

  provinceClick() {
    // 更新下拉框的列表
    this.copyList = deepCopy(this.templateService.getTemplateByRefMap(this.type, this.item));
    for (let i = 0; i < this.copyList.length; i++) {
      this.copyList[i].name = this.copyList[i].name + '【' + _MSGTYPES.getMsgByType(false, this.copyList[i].msgType).name + '】';
    }
    if (this.type == 8) {
      this.copyList = this.copyList.filter(item => {
        return item.msgType == 8;
      });
    }
  }
}
